export default "__VITE_ASSET__DaKz$HIu__"